import { render, staticRenderFns } from "./IngredientNutrients.vue?vue&type=template&id=55fb4b3f&scoped=true&"
import script from "./IngredientNutrients.vue?vue&type=script&lang=js&"
export * from "./IngredientNutrients.vue?vue&type=script&lang=js&"
import style0 from "./IngredientNutrients.vue?vue&type=style&index=0&id=55fb4b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb4b3f",
  null
  
)

export default component.exports